export const contactTypes: any[] = [
  {field: "siteContact", name: "Site Contact"},
  {field: "deliveryContact", name: "Delivery Contact"},
  {field: "installationContact", name: "Installation Contact"},
  {field: "tonerContact", name: "Toner Contact"},
  {field: "orderStatusNotification1", name: "ASM Contact 1"},
  {field: "orderStatusNotification2", name: "ASM Contact 2"},
  {field: "itContact", name: "IT Contact"},
  {field: "managerContact", name: "Manager Contact"},
  {field: "alternateContact", name: "Alternate Contact"},
  {field: "breakfixContact", name: "Breakfix Contact"},
];
